const role = {
  id: 0,
  name: ''
}

export default role
